module.exports = __webpack_public_path__ + "2bb2ff50cd3adc1d0cd88e78539a7c25.svg";